import { render } from "./readMoreBlogs.vue?vue&type=template&id=a443342e&scoped=true&ts=true"
import script from "./readMoreBlogs.vue?vue&type=script&lang=ts"
export * from "./readMoreBlogs.vue?vue&type=script&lang=ts"

import "./readMoreBlogs.vue?vue&type=style&index=0&id=a443342e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a443342e"]])

export default __exports__